exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slider{\n    width: 100%;\n}\n.range-slider-fill{\n    background-color: green;\n}\n", ""]);

// exports
